module.exports = __webpack_public_path__ + "components/page-header/static/icon-caret-down--black-911af955d3adf0f2450f7a1394ba14ad.svg";